import { useState } from "react";
import CarouselGaleria from "./CarouselGaleria";

const Galeria = ({ images, onClose }: any) => {
  const [zoom, setZoom] = useState(false);

  if(zoom){
    return (
      <CarouselGaleria images={images} onClose={setZoom}/>
    )
  }


  return (
    <div
      className="bg-white w-full h-screen overflow-auto lg:flex justify-center py-[10px] lg:py-[70px]"
      style={{
        position: "absolute",
        top: "0px",
        zIndex: 51,
        left: "0px",
        right: "0px",
        border: "0px solid red",
      }}
    >
      <div className="py-6 px-3 fixed border w-full bg-white" style={{ zIndex: 2, top: 0 }}>
        <label
          className="cursor-pointer hover:bg-gray-20 border px-4 py-3  text-dark font-bold"
          style={{ borderRadius: "10px" }}
        >
          X Cerrar
          <button className="hidden" onClick={onClose}></button>
        </label>
      </div>

      <div className="relative w-full container mx-auto  lg:pt-[100px] pt-[100px] lg:px-[50px] lg:px-[250px] ">
        <div
          className="masonry overflow-hidden"
          style={{
            columnCount: "2",
            columnGap: "0.3rem",
          }}
        >
          {images.map((img: any, index: any) => {
            return (
              <label className="cursor-pointer  bg-black">
                <img
                  src={img.url}
                  alt="Imagen 1"
                  className=" masonry-item rounded-sm shadow-lg object-cover w-full h-full transition-opacity duration-300 hover:opacity-75"
                  style={{
                    breakInside: "avoid",
                    marginBottom: "0.3rem",
                  }}
                  onContextMenu={(e) => e.preventDefault()}
                  key={index}
                ></img>
                <button className="hidden"
                onClick={() => setZoom(true)}
                ></button>
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Galeria;
